"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/DateInput/YearMonthForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _keyboard = require('web/services/keyboard');

const currentYear = new Date().getFullYear()

const fromMonth = new Date(currentYear - 100, 11)
const toMonth = new Date(currentYear, 0)

const fromYear = fromMonth.getFullYear()
const toYear = toMonth.getFullYear()

const birthYears = []
for (let i = fromYear; i <= toYear; i++) birthYears.push(i)











const YearMonthForm = ({
  date,
  localeUtils,
  onChange,
  onPrevMonth,
  onNextMonth,
  years = birthYears,
}) => {
  const months = localeUtils.getMonths()

  const selectedMonth = date.getMonth()
  const selectedYear = date.getFullYear()

  const handleChangeMonth =
    e => onChange(new Date(selectedYear, +e.target.value))
  const handleChangeYear =
    e => onChange(new Date(+e.target.value, selectedMonth))

  return (
    _react2.default.createElement('div', { className: "DayPicker-Caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
      , _react2.default.createElement('div', { className: "blm-date-picker--caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
        , _react2.default.createElement('select', {
          name: "month",
          className: "blm-date-picker--month-select",
          onChange: handleChangeMonth,
          value: selectedMonth, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}

          ,  months.map((m, i) => _react2.default.createElement('option', { key: m, value: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}},  m )) 
        )
        , _react2.default.createElement('select', {
          name: "year",
          className: "blm-date-picker--year-select",
          onChange: handleChangeYear,
          value: selectedYear, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}

          ,  years.map(y => (_react2.default.createElement('option', { key: y, value: y, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}},  y ))) 
        )
        , _react2.default.createElement('div', { className: "blm-date-picker--controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement('div', {
            role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
            'aria-label': "Previous month" ,
            onClick: onPrevMonth,
            className: "blm-date-picker--prev-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          )
          , _react2.default.createElement('div', {
            role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
            'aria-label': "Next month" ,
            onClick: onNextMonth,
            className: "blm-date-picker--next-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
          )
        )
      )
    )
  )
}

exports. default = YearMonthForm
